module.exports = __webpack_public_path__ + "static/media/theatre-landingP.5101fc6e.jpg";